import React, { useContext } from "react";
import { LanguageContext } from '../components/LanguageContext';

const ContactUs = () => {
  const { language } = useContext(LanguageContext);

  return (
    <>
      {/* Header Section */}
      <div className="relative">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt={language === 'en' ? "Contact Us Header" : "ہم سے رابطہ کریں ہیڈر"} 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-3xl md:text-5xl font-bold mb-4">
                  {language === 'en' ? "Contact Us" : "ہم سے رابطہ کریں"}
                </h1>
                <p className="text-lg md:text-xl">
                  {language === 'en' ? "Get in touch with us for any inquiries or support" : "کسی بھی سوال یا مدد کے لیے ہم سے رابطہ کریں"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Information Section */}
      <section className="py-6 md:py-12 bg-gray-50">
        <div className="container mx-auto px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12">
            
            {/* Office Address */}
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-2">
                {language === 'en' ? "Office Address" : "دفتر کا پتہ"}
              </h3>
              <p className="text-gray-600">
                {language === 'en' 
                  ? "Andhra Pradesh State Urdu Academy" 
                  : "آندھرا پردیش اسٹیٹ اردو اکیڈمی"}<br />
                {language === 'en'
                  ? "D.No: 11-83/2, 2nd Floor, Above TVS showroom"
                  : "D.No: 11-83/2، دوسری منزل، ٹی وی ایس شوروم کے اوپر"}<br />
                {language === 'en'
                  ? "GNT Road, Mangalagiri"
                  : "جی این ٹی روڈ، منگل اگری"}<br />
                {language === 'en'
                  ? "522503, Guntur District, Andhra Pradesh"
                  : "522503، گنٹور ضلع، آندھرا پردیش"}
              </p>
            </div>

            {/* Contact Details */}
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-2">
                {language === 'en' ? "Contact Details" : "رابطے کی تفصیلات"}
              </h3>
              <p className="text-gray-600">
                 apsua@apstateurduacademy.com<br />
                 director.secretary@apstateurduacademy.com
              </p>
            </div>

            {/* Working Hours */}
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-blue-800 mb-2">
                {language === 'en' ? "Working Hours" : "کام کے اوقات"}
              </h3>
              <p className="text-gray-600">
                {language === 'en' ? "Monday - Friday" : "پیر - جمعہ"}:<br />
                9:00 AM - 6:00 PM
              </p>
              <p className="text-gray-600 mt-2">
                {language === 'en' ? "Saturday" : "ہفتہ"}:<br />
                10:00 AM - 4:00 PM
              </p>
              <p className="text-gray-600 mt-2">
                {language === 'en' ? "Sunday: Closed" : "اتوار: بند"}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="pb-6 md:pb-12 bg-gray-50">
        <div className="container mx-auto px-8">
          <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">
            {language === 'en' ? "Our Location" : "ہمارا مقام"}
          </h2>
          <div className="w-full h-[400px] bg-gray-200 rounded-lg shadow-lg">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3827.0780498378385!2d80.56123707514344!3d16.42086198431071!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTbCsDI1JzE1LjEiTiA4MMKwMzMnNDkuNyJF!5e0!3m2!1sen!2sin!4v1780150583824!5m2!1sen!2sin"
              width="100%" 
              height="100%" 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
